<template>
  <div class="paper-choice-student-second">
    <TemplateDataGrid ref="grid"
                      gridId="PaperChoiceStudentSecond"
                      v-bind="gridParams"></TemplateDataGrid>
  </div>
</template>

<script>
import TemplateDataGrid from '../../../../../../../templates/TemplateDataGrid'
export default {
  name: 'PaperChoiceStudentSecond',
  components: {
    TemplateDataGrid
  },
  props: {
    paperBatchId: {
      type: String,
      required: true
    },
    activeTab: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    gridParams () {
      return {
        paperBatchId: this.paperBatchId
      }
    }
  },
  watch: {
    activeTab: {
      handler (val) {
        if (val) {
          const grid = this.$refs.grid
          if (grid) {
            grid.loadGridData()
          }
        }
      },
      immediate: true
    },
    gridParams: {
      handler: function () {
        if (!this.activeTab) {
          return
        }
        this.$nextTick(() => {
          const grid = this.$refs.grid
          grid && grid.loadGridData()
        })
      },
      deep: true
    }
  }
}
</script>

<style scoped lang="scss">
.paper-choice-student-second{
  height: 100%;
}
</style>
